import { render, staticRenderFns } from "./PlushieShipmentInfo.vue?vue&type=template&id=41582308&scoped=true&"
import script from "./PlushieShipmentInfo.vue?vue&type=script&lang=ts&"
export * from "./PlushieShipmentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieShipmentInfo.vue?vue&type=style&index=0&id=41582308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41582308",
  null
  
)

export default component.exports